import { z } from "zod";

/**
 * Shared validation refinement for solicitor selection.
 * Validates based on whether user has existing solicitor or wants suggestions.
 *
 * This validation is used by both the main form schema and Storybook stories
 * to ensure consistency across the application.
 *
 * @param data - The form data containing hasExistingSolicitor, existingSolicitor, and selectedSolicitors
 * @param ctx - Zod refinement context for adding validation issues
 */
export function validateSolicitorSelection(
  data: {
    hasExistingSolicitor?: "yes" | "no";
    existingSolicitor?: { firmId: number; name: string };
    selectedSolicitors: { firmId: number; organisationId: number | null }[];
  },
  ctx: z.RefinementCtx,
): void {
  // First, check if user has answered the existing solicitor question
  if (!data.hasExistingSolicitor) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Please select an option before continuing",
      path: ["hasExistingSolicitor"],
    });
    return;
  }

  // If user has existing solicitor, validate that one is selected
  if (data.hasExistingSolicitor === "yes") {
    if (!data.existingSolicitor) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please select a Solicitor before continuing.",
        path: ["existingSolicitor"],
      });
    }
  }

  // If user wants suggestions, validate at least one solicitor is selected
  if (data.hasExistingSolicitor === "no") {
    if (data.selectedSolicitors.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please select at least one Solicitor Estate Agent before continuing.",
        path: ["selectedSolicitors"],
      });
    }
  }
}
